export default "__VITE_ASSET__cc69d7ba__"